import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 relative z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center" onClick={() => setOpen(false)}>
            <img
              src="/waybook-logo.svg"
              alt="Waybook"
              className="h-8"
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/recommended"
              className="text-gray-700 hover:text-black"
            >
              Recommended
            </Link>
            <Link
              to="/roadmap"
              className="text-gray-700 hover:text-black"
            >
              Roadmap
            </Link>
            <Link
              to="/press-release"
              className="text-gray-700 hover:text-black"
            >
              Press Release
            </Link>
            <Link
              to="/contact"
              className="text-gray-700 hover:text-black"
            >
              Contact
            </Link>
            <a
              href="/#subscribe"
              className="bg-waybook-green text-black px-6 py-2 hover:bg-waybook-green-600 transition-colors rounded-lg"
            >
              Coming Soon
            </a>
          </nav>

          {/* Mobile menu button */}
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-md border border-gray-300 text-gray-800 hover:bg-gray-100"
            aria-controls="mobile-menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span className="sr-only">Toggle navigation</span>
            {open ? (
              // Close icon
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              // Hamburger icon
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="w-5 h-5">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>
      </div>

      {/* Mobile menu panel */}
      <div
        id="mobile-menu"
        className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-300 ${open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`}
      >
        <div className="mx-4 sm:mx-6 lg:mx-8 mt-2 mb-4 rounded-lg border border-gray-200 bg-white">
          <nav className="flex flex-col p-2">
            <Link
              to="/recommended"
              className="px-3 py-2 rounded-md text-gray-800 hover:bg-gray-100"
              onClick={() => setOpen(false)}
            >
              Recommended
            </Link>
            <Link
              to="/roadmap"
              className="px-3 py-2 rounded-md text-gray-800 hover:bg-gray-100"
              onClick={() => setOpen(false)}
            >
              Roadmap
            </Link>
            <Link
              to="/press-release"
              className="px-3 py-2 rounded-md text-gray-800 hover:bg-gray-100"
              onClick={() => setOpen(false)}
            >
              Press Release
            </Link>
            <Link
              to="/contact"
              className="px-3 py-2 rounded-md text-gray-800 hover:bg-gray-100"
              onClick={() => setOpen(false)}
            >
              Contact
            </Link>
            <a
              href="/#subscribe"
              className="mt-2 mx-2 inline-flex items-center justify-center rounded-md bg-waybook-green text-black px-5 py-2 hover:bg-waybook-green-600 transition-colors"
              onClick={() => setOpen(false)}
            >
              Coming Soon
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}
